<app-base-inline-form
  i18n-submitText
  submitText="Show Details"
  submitIcon="receipt"
  [fields]="searchFields"
  [model]="model"
  (submitted)="getModel($event)"
></app-base-inline-form>

<app-base-form [fields]="fields" [id]="productId"> </app-base-form>
